import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { EmpresaAdminStore } from "../../stores/admin/EmpresaAdminStore";
import { formatCnpj } from "../../utils";
import { AppStore } from "../../stores/AppStore";
import { IconButton } from "@mui/material";
import { Button, Classes, Dialog, FormGroup, HTMLSelect, InputGroup, Tab, Tabs } from "@blueprintjs/core";
import { MDBBtn, MDBCol } from "mdbreact";
import moment from "moment";
import { SenhaCopiavel } from "./SenhaCopiavel";
import { UserCopiavel } from "./UserCopiavel";
import { AppIcon } from "../utils/AppIcon";

var debounce = require('lodash.debounce');

interface Props {}

interface State {
  visivel: boolean
}

@observer
export class EmpresasAdminPage extends React.Component<Props, State> {

  obs = observable({
    currentPage: 1 as number,
    filters_empresa: { razao_social: "", cnpj: "", municipio: "", uf: "", regime_importacao: "", ativo: "0" },
    filters_conta: { nome: "", razao_social: "", cnpj: "", ativo: "0" },
    open_filters: false,
    open_modal_detalhes: false,
    itens: {} as any,
    fetchOptions: {} as any
  })

  constructor(props) {
    super(props);

    this.obs.fetchOptions = debounce(this.handlePageChange.bind(this), 800);

    this.state = {
      visivel: false
    };

  }

  async componentDidMount(): Promise<void> {
    AppStore.setTitle("Empresas Admin");

    await EmpresaAdminStore.handleLoadEmpresas(1, this.obs.filters_empresa, this.obs.filters_conta)

  }

  async handlePageChange(page) {

    this.obs.currentPage = page

    await EmpresaAdminStore.handleLoadEmpresas(page, this.obs.filters_empresa, this.obs.filters_conta)

  }

  handleQueryFilters(e) {

    this.obs.fetchOptions(1)

  }

  openDetalhesEmpresa(row) {

    this.obs.itens = row

    this.obs.open_modal_detalhes = true

  }

  handleClearFiltros() {

    this.obs.open_filters = false

    this.obs.filters_empresa = { razao_social: "", cnpj: "", municipio: "", uf: "", regime_importacao: "", ativo: "0" }

    this.obs.filters_conta = { nome: "", razao_social: "", cnpj: "", ativo: "0" }

    this.handlePageChange(1)

  }

  formatterModeloLogin(modelo) {

    switch (modelo) {
      case "certificado": return "Certificado do Sócio"
      case "senha": return "CPF e Senha"
      case "gov": return "GOV (Certificado)"
      case "gov_senha": return "GOV (CPF / Senha)"
      default: return "Nenhum modelo selecionado"
    }

  }

  async handleDownloadPfx(empresa: string, conta_id: string, senha: string, tipo: string) {

    await EmpresaAdminStore.downloadEmpresaPfx(empresa, conta_id, senha, tipo)

  }

  certificadoFormat(certificado: string) {

    const startDate = moment().toDate();

    const dataHoje = moment(startDate).format("YYYY-MM-DD");

    if (certificado <= dataHoje) {

      return (<span style={{ color: "red" }}>Expirado (Val: {moment(certificado).format("DD/MM/YYYY")})</span>)

    } else {

      return (<span style={{ color: "green" }}>Vigente (Val: {moment(certificado).format("DD/MM/YYYY")})</span>)

    }

  }

  PfxDownload(label: string, empresa: string, conta_id: string, senha: string, tipo: string) {

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "1em", marginBottom: "0.5em" }}>

        <label style={{ minWidth: "60px", marginBottom: 0 }}>{label}:</label>

        <IconButton onClick={() => this.handleDownloadPfx(empresa, conta_id, senha, tipo)} style={{ background: "none", border: "none", cursor: "pointer" }}>
          <AppIcon name="sim_card_download" size={20} style={{ color: "#3579ea" }} />
        </IconButton>

      </div>
    );

  }

  render() {

    let estadosOption = [
      { label: "TODOS", value: "" },
      { label: "AC", value: "AC" },
      { label: "AL", value: "AL" },
      { label: "AP", value: "AP" },
      { label: "AM", value: "AM" },
      { label: "BA", value: "BA" },
      { label: "CE", value: "CE" },
      { label: "DF", value: "DF" },
      { label: "ES", value: "ES" },
      { label: "GO", value: "GO" },
      { label: "MA", value: "MA" },
      { label: "MT", value: "MT" },
      { label: "MS", value: "MS" },
      { label: "MG", value: "MG" },
      { label: "PA", value: "PA" },
      { label: "PB", value: "PB" },
      { label: "PR", value: "PR" },
      { label: "PE", value: "PE" },
      { label: "PI", value: "PI" },
      { label: "RJ", value: "RJ" },
      { label: "RN", value: "RN" },
      { label: "RS", value: "RS" },
      { label: "RO", value: "RO" },
      { label: "RR", value: "RR" },
      { label: "SC", value: "SC" },
      { label: "SP", value: "SP" },
      { label: "SE", value: "SE" },
      { label: "TO", value: "TO" }
    ]

    function ativaFormatter(cell, row) {

      return (
        <>
          {cell
            ? <img src="/images/checked.png" width="20px" />
            : <img src="/images/block.png" width="20px" />
          }
        </>
      );
    }

    let empresas = EmpresaAdminStore.obs.empresas?.map(emp => {
      return ({
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: formatCnpj(emp.cnpj),
        regime_importacao: emp.regime_importacao,
        uf: emp.uf,
        municipio: emp.municipio,
        ativo: emp.ativo,
        conta_ativa: emp.conta.ativo,
        conta_nome: emp.conta.nome || emp.conta.razao_social,
        empresa: emp,
      })
    });

    const btnDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm" onClick={(e) => this.openDetalhesEmpresa(row.empresa)}>
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    return (

      <>

        <FormGroup>
          <IconButton style={{ float: "right" }} onClick={() => this.handleClearFiltros()}>
            <AppIcon name="close" color="rgb(211, 47, 47)" />
          </IconButton>

          <IconButton style={{ float: "right" }} onClick={() => this.obs.open_filters = !this.obs.open_filters}>
            <AppIcon name="filter_list" />
          </IconButton>

        </FormGroup>

        {this.obs.open_filters && <>

          <FormGroup label="Empresa">

            <div style={{ border: "1px solid rgba(27, 99, 111, 0.5)", padding: 10, borderRadius: 10 }}>

              <div style={{ display: "flex" }}>

                <FormGroup label="Razão Social" style={{ width: "50%" }}>
                  <InputGroup placeholder="Filtrar Razão Social" value={this.obs.filters_empresa.razao_social} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.razao_social = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="CNPJ" style={{ width: "50%" }}>
                  <InputGroup placeholder="Filtrar CNPJ" value={this.obs.filters_empresa.cnpj} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.cnpj = e.target.value)} />
                </FormGroup>

              </div>

              <div style={{ display: "flex" }}>

                <FormGroup label="Município" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar Município" value={this.obs.filters_empresa.municipio} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.municipio = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="UF" style={{ width: "25%" }}>
                  <HTMLSelect onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.uf = e.target.value)} value={this.obs.filters_empresa.uf}>
                    {estadosOption?.map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </HTMLSelect>
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Regime da Empresa" style={{ width: "25%" }}>
                  <HTMLSelect value={this.obs.filters_empresa.regime_importacao} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.regime_importacao = e.target.value)}>
                    <option value="">TODAS</option>
                    <option value="CAIXA">CAIXA</option>
                    <option value="COMPETÊNCIA">COMPETÊNCIA</option>
                  </HTMLSelect>
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Ativa" style={{ width: "25%" }}>
                  <HTMLSelect value={this.obs.filters_empresa.ativo} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.ativo = e.target.value)}>
                    <option value="0">TODAS</option>
                    <option value="1">ATIVAS</option>
                    <option value="2">DESATIVADAS</option>
                  </HTMLSelect>
                </FormGroup>
              </div>

            </div>

          </FormGroup>

          <FormGroup label="Conta">

            <div style={{ border: "1px solid rgba(27, 99, 111, 0.5)", padding: 10, borderRadius: 10 }}>

              <div style={{ display: "flex" }}>
                <FormGroup label="Nome" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar Conta Nome" value={this.obs.filters_conta.nome} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.nome = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Razão Social" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar Razão Social" value={this.obs.filters_conta.razao_social} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.razao_social = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="CNPJ" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar CNPJ" value={this.obs.filters_conta.cnpj} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.cnpj = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Ativa" style={{ width: "25%" }}>
                  <HTMLSelect value={this.obs.filters_conta.ativo} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.ativo = e.target.value)}>
                    <option value="0">TODAS</option>
                    <option value="1">ATIVAS</option>
                    <option value="2">DESATIVADAS</option>
                  </HTMLSelect>
                </FormGroup>
              </div>

            </div>

          </FormGroup>

        </>}

        <BootstrapTable className="TableDefault" ref="table" data={empresas}>
          <TableHeaderColumn dataField="_id" isKey={true} hidden>#</TableHeaderColumn>
          <TableHeaderColumn dataField="razao_social" width={"30%"}>Razão Social</TableHeaderColumn>
          <TableHeaderColumn dataField="cnpj" width={"10%"}>CNPJ</TableHeaderColumn>
          <TableHeaderColumn dataField="regime_importacao" width={"10%"}>Regime Importação</TableHeaderColumn>
          <TableHeaderColumn dataField="uf" width={"5%"}>UF</TableHeaderColumn>
          <TableHeaderColumn dataField="municipio" width={"10%"}>Município</TableHeaderColumn>
          <TableHeaderColumn dataFormat={ativaFormatter} dataField="ativo" width="5%">Ativa</TableHeaderColumn>
          <TableHeaderColumn dataField="conta_nome" width={"20%"}>Conta / Razão Social</TableHeaderColumn>
          <TableHeaderColumn dataFormat={ativaFormatter} dataField="conta_ativa" width="5%">Ativa</TableHeaderColumn>
          <TableHeaderColumn dataFormat={btnDetalhes} width={"5%"}>Detalhes</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.currentPage}
            totalCount={EmpresaAdminStore.obs.empresas_length}
            pageSize={20}
            onPageChange={page => this.handlePageChange(page)}
          />
        </div>

        <Dialog
          isOpen={this.obs.open_modal_detalhes}
          onClose={() => this.obs.open_modal_detalhes = false}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <Tabs id="tabs" className="tabsCalculos tabsCentral">
              <Tab id="dados" title="Dados da Empresa" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <p><span>Identificador:</span> {this.obs.itens?._id}</p>
                  <p><span>CNPJ:</span> {this.obs.itens?.cnpj}</p>
                  <p><span>Razão Social:</span> {this.obs.itens?.razao_social}</p>
                  <p><span>Nome Fantasia:</span> {this.obs.itens?.nome_fantasia}</p>
                  <p><span>Apelido:</span> {this.obs.itens?.apelido}</p>
                  <p><span>Inscrição Estadual:</span> {this.obs.itens?.inscricao_estadual}</p>
                  <p><span>Tipo de Cadastro:</span>{" "}{this.obs.itens?.filial ? "FILIAL" : "MATRIZ"}</p>
                  <p><span>Regime da Empresa:</span> {this.obs.itens?.regime_importacao}</p>
                  <p><span>Municipio:</span> {this.obs.itens?.municipio}</p>
                  <p><span>Estado:</span> {this.obs.itens?.uf}</p>
                  <p><span>Cadastrada:</span> {moment(this.obs.itens?.inserted_at).format("DD/MM/YYYY")}</p>
                </MDBCol>
              } />
              <Tab id="certificados" title="Certificados" panel={
                <MDBCol md="12" className="empresa-admin-modal">

                  <div className="info-bloco">
                    {this.obs.itens?.certificado ? (
                      <>
                        <p style={{ marginBottom: 0 }}><strong>Essa empresa possui um certificado em uso:</strong> {this.certificadoFormat(this.obs.itens?.certificado)}</p>
                        {this.PfxDownload("PFX", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens?.senha_certificado, "certificado")}
                        <SenhaCopiavel valor={this.obs.itens?.senha_certificado} label="Senha" />
                      </>
                    ) : (
                      <p><strong>Essa empresa não possui certificado.</strong></p>
                    )}
                  </div>

                  <br/>

                  <div className="info-bloco">
                    {this.obs.itens?.certificado_socio ? (
                      <>
                        <p style={{ marginBottom: 0 }}><strong>Essa empresa possui um certificado do sócio em uso:</strong> {this.certificadoFormat(this.obs.itens?.certificado_socio)}</p>
                        {/* {this.PfxDownload("PFX sem Senha", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens?.senha_certificado_socio, "socio")} */}
                        {this.PfxDownload("PFX", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens?.senha_certificado_socio, "socio_senha")}
                        <SenhaCopiavel valor={this.obs.itens?.senha_certificado_socio} label="Senha" />
                      </>
                    ) : (
                      <p><strong>Essa empresa não possui certificado do sócio.</strong></p>
                    )}
                  </div>

                  <br/>

                  <div className="info-bloco">
                    {this.obs.itens?.certificado_socio ? (
                      <>
                        <p style={{ marginBottom: 0 }}><strong>Essa conta possui um certificado do contador em uso:</strong> {this.certificadoFormat(this.obs.itens.conta?.certificado)}</p>
                        {this.PfxDownload("PFX", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens.conta?.senha_certificado, "conta")}
                        <SenhaCopiavel valor={this.obs.itens.conta?.senha_certificado} label="Senha" />
                      </>
                    ) : (
                      <p><strong>Essa conta não possui um certificado do contador.</strong></p>
                    )}
                  </div>

                </MDBCol>
              } />
              <Tab id="sefa" title="SEFA" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <div className="info-bloco">
                    <p><strong>Método de autenticação na SEFA:</strong> {this.formatterModeloLogin(this.obs.itens?.sefa_metodo_login)}</p>
                  </div>

                  <div className="info-bloco">
                    <p style={{ marginBottom: 0 }}><strong>Login SEFA:</strong></p>
                    <UserCopiavel valor={this.obs.itens?.cpf_sefa} label="Usuário" />
                    <SenhaCopiavel valor={this.obs.itens?.senha_sefa} label="Senha" />
                  </div>

                  <br />

                  <div className="info-bloco">
                    <p style={{ marginBottom: 0 }}><strong>Login GOV:</strong></p>
                    <UserCopiavel valor={this.obs.itens?.cpf_gov} label="Usuário" />
                    <SenhaCopiavel valor={this.obs.itens?.senha_gov} label="Senha" />
                  </div>

                </MDBCol>
              } />
              <Tab id="Tributações" title="Tributações" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <p><span>Regime Simples Nacional:</span>{" "}{this.obs.itens?.simples_nacional ? "Sim" : "Não"}</p>
                  <p><span>Excesso de Sublimite de Receita Bruta:</span>{" "}{this.obs.itens?.simples_nacional_excesso ? "Sim" : "Não"}</p>
                  <p><span>Regime Especial:</span>{" "}{this.obs.itens?.regime_especial_icms_pa ? "Sim" : "Não"}</p>
                  <p><span>Convênio ICMS 100/97:</span>{" "}{this.obs.itens?.convenio_icms_100_97 ? "Sim" : "Não"}</p>
                  <p><span>Comercializa Medicamentos Veterinários, PET.:</span>{" "}{this.obs.itens?.medicamento_uso_veterinario ? "Sim" : "Não"}</p>
                  <p><span>Comercializa Produtos Autopeças:</span> {this.obs.itens?.auto_pecas ? "Sim" : "Não"}</p>
                  <p><span>Operação de Venda na Modalidade Porta a Porta:</span> {this.obs.itens?.porta_a_porta ? "Sim" : "Não"}</p>
                </MDBCol>
              } />
              <Tab id="conta" title="Dados da Conta" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <p><span>Identificador:</span> {this.obs.itens.conta?.id}</p>
                  <p><span>Nome:</span> {this.obs.itens.conta?.nome}</p>
                  <p><span>CNPJ:</span> {this.obs.itens.conta?.cnpj}</p>
                  <p><span>Razão Social:</span> {this.obs.itens.conta?.razao_social}</p>
                  <p><span>Logradouro:</span> {this.obs.itens.conta?.logradouro || this.obs.itens.conta?.rua}</p>
                  <p><span>Número:</span> {this.obs.itens.conta?.numero}</p>
                  <p><span>Bairro:</span> {this.obs.itens.conta?.bairro}</p>
                  <p><span>Cidade:</span> {this.obs.itens.conta?.cidade}</p>
                  <p><span>Estado:</span> {this.obs.itens.conta?.uf || this.obs.itens.conta?.estado}</p>
                  <p><span>Cep:</span> {this.obs.itens.conta?.cep}</p>
                  <p><span>Telefone:</span> ({this.obs.itens.conta?.ddd}) {this.obs.itens.conta?.telefone}</p>
                  <p><span>Cadastrada:</span> {moment(this.obs.itens.conta?.inserted_at).format("DD/MM/YYYY")}</p>
                </MDBCol>
              } />
            </Tabs>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_modal_detalhes = false} />
            </div>
          </div>

        </Dialog>

      </>

    )
  }

}